import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 35px 30px 50px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 100px;
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 50px 15px;
  }
`;

export const ButtonContainer = styled(Link)`
  width: fit-content;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  border: none;
  justify-content: center;
  border-radius: 5px;
  margin-top: 10px;
  text-decoration: none;

  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blue};
  font-family: "Mangueira Bold";

  &:hover {
    color: ${({ theme }) => theme.colors.white};
    text-decoration: none;
    opacity: 80%;
  }
`;

export const ContentImg = styled.div`
  border-radius: 0 100% 100% 0;
  width: 35%;
  position: relative;
  margin-top: -100px;
  height: fit-content;

  @media (max-width: 768px) {
    width: 55%;
    margin-top: -50px;
  }
`;

export const Img = styled.img`
  border-radius: 0 0 100% 100%;
  width: 100%;
`;

export const Title = styled.h1`
  font-size: 26px;
  text-align: center;
  font-family: "Mangueira Bold";
  color: ${({ theme }) => theme.colors.blue};
  margin: 0;
`;

export const Text = styled.h2`
  font-size: 18px;
  text-align: center;
  color: ${({ theme }) => theme.colors.secondaryText};
  margin: 0;
`;
